export default __webpack_public_path__ + "static/media/Punto_03_Monumento_4_Mori_e_Fortezza_Vecchia_DEU_Def.5d7b0c0b.aac";